// ─── DOMAINS ─────────────────────────────────────────────────────────────────
// Source: Section 4 — 6 Domains with Adaptive Intelligence (updated document)
// NOTE: Cybersecurity removed. Absentee Ballot is now Domain 6 (HIGH PRIORITY).

export const DOMAINS = [
  {
    id: 1,
    name: "Poll Worker Management",
    shortName: "Poll Workers",
    icon: "👥",
    color: "#3B82F6",
    colorRgb: "59,130,246",
    coreQCount: 3,
    adaptiveQRange: "0–2",
    strategicGoal: "Expose coordination chaos",
    description: "Streamlines recruitment, scheduling, training, and tracking of poll workers",
    product: "Poll Worker Management",
    weight: "Standard",
    pointsRange: "12–20",
  },
  {
    id: 2,
    name: "Election Asset Management",
    shortName: "Asset Management",
    icon: "🗳️",
    color: "#8B5CF6",
    colorRgb: "139,92,246",
    coreQCount: 4,
    adaptiveQRange: "0–1",
    strategicGoal: "Reveal visibility gaps",
    description: "Manages voting equipment, consumables, logic & accuracy testing workflows",
    product: "Election Asset Management",
    weight: "Standard",
    pointsRange: "15–25",
  },
  {
    id: 3,
    name: "Policy AI / Legal Response",
    shortName: "Policy AI",
    icon: "⚖️",
    color: "#F59E0B",
    colorRgb: "245,158,11",
    coreQCount: 2,
    adaptiveQRange: "0–1",
    strategicGoal: "Show legal delay costs",
    description: "AI-powered chatbot providing instant answers on election laws and regulations",
    product: "Policy AI",
    weight: "Standard",
    pointsRange: "8–15",
  },
  {
    id: 4,
    name: "Support IQ",
    shortName: "Support IQ",
    icon: "🎧",
    color: "#10B981",
    colorRgb: "16,185,129",
    coreQCount: 2,
    adaptiveQRange: "0–1",
    strategicGoal: "Surface issue tracking failures",
    description: "Ticketing and help desk system for election operations teams",
    product: "Support IQ",
    weight: "Standard",
    pointsRange: "8–15",
  },
  {
    id: 5,
    name: "Analytics & FOIA Readiness",
    shortName: "Analytics & FOIA",
    icon: "📊",
    color: "#EF4444",
    colorRgb: "239,68,68",
    coreQCount: 2,
    adaptiveQRange: "0",
    strategicGoal: "Expose transparency gaps",
    description: "Finance-based analytics on voter data and FOIA/Open Records management",
    product: "Analytics Hub",
    weight: "Standard",
    pointsRange: "6–10",
  },
  {
    id: 6,
    name: "Absentee Ballot Portal",
    shortName: "Absentee Ballot",
    icon: "📬",
    color: "#F97316",
    colorRgb: "249,115,22",
    coreQCount: 3,
    adaptiveQRange: "0–1",
    strategicGoal: "Legal/public risk — compliance wedge",
    description: "End-to-end absentee ballot management: intake, verification, tracking, curing workflows",
    product: "Absentee Ballot Portal",
    weight: "PREMIUM",
    pointsRange: "11–20",
    premium: true,
    highPriority: true,
    complianceWedge: true,
  },
];

export const getDomain = (id) => DOMAINS.find((d) => d.id === id);
